import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, Link } from "react-router-dom";
import { CollectionContext } from "../Contexts/CollectionContext";
import { AdminContext } from "../Contexts/AdminContext";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";

const CollectionView = () => {
  const { allCollections, deleteCollection } = useContext(CollectionContext);
  const { logout } = useContext(AdminContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);
  const collectionsPerPage = 10;

  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredCollection = allCollections.filter((col) =>
    col?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastcollection = currentPage * collectionsPerPage;
  const indexOfFirstCollection = indexOfLastcollection - collectionsPerPage;
  const currentCollection = filteredCollection.slice(
    indexOfFirstCollection,
    indexOfLastcollection
  );

  const totalPages = Math.ceil(filteredCollection.length / collectionsPerPage);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleSearch = () => {
    setCurrentPage(1);
  };

  const openDeleteModal = (id) => {
    setSelectedCollectionId(id);
    setIsModalOpen(true);
  };

  const handleDeleteCollection = async () => {
    try {
      await deleteCollection(selectedCollectionId);
      setIsModalOpen(false);
      navigate("/admin/view/collections");
    } catch (error) {
      console.error("Error deleting collection:", error);
    }
  };

  return (
    <div>
      <div className="p-4">
        <div className="mb-4 relative">
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Search Team collection..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full p-2 border rounded-l-lg"
            />
            <button
              className="p-2 rounded-r-lg bg-secondary text-white"
              onClick={handleSearch}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 p-4 md:px-0 lg:px-12 py-20">
          {currentCollection.map((col) => (
            <div>
              <div className="relative overflow-hidden rounded-lg shadow-lg">
                <Link
                  to={`/shop/${col._id}/artworks`}
                  onClick={() => logout()}
                  className="relative overflow-hidden rounded-lg shadow-lg group"
                >
                  <img
                    src={`${col.image}`}
                    alt={col.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute bottom-4 left-4 text-black p-5">
                    <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold">
                      {col.name}
                    </h3>
                  </div>
                </Link>
              </div>
              <div className="flex space-x-4 py-6">
                <Link to={`/admin/edit/collections/${col._id}`}>
                  <button className="inline-block mt-4 md:mt-0 md:ml-4 px-4 py-1 bg-primary font-poppins text-white shadow-lg hover:bg-secondary transition duration-300 transform hover:scale-105 no-underline ml-6">
                    Edit
                  </button>
                </Link>
                <button
                  className="inline-block mt-4 md:mt-0 md:ml-4 px-4 py-1 bg-black font-poppins text-white shadow-lg hover:bg-secondary transition duration-300 transform hover:scale-105 no-underline ml-6"
                  onClick={() => openDeleteModal(col._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="bttn bttn--green bttn--small"
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="bttn bttn--green bttn--small"
          >
            Next
          </button>
        </div>
      </div>
      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleDeleteCollection}
      />
    </div>
  );
};

export default CollectionView;
